var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loader",style:({'margin': _vm.center ? '0 auto' : '0'})},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"}),_c('div',{staticClass:"bar4"}),_c('div',{staticClass:"bar5"}),_c('div',{staticClass:"bar6"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }